import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DetailsTabComponent } from './detailsTab.component';
import { ButtonModule } from '@app/components/button/button.module';
import { TranslateModule } from '@ngx-translate/core';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';

@NgModule({
  imports: [CommonModule, ButtonModule, TranslateModule, PlIconModule],
  declarations: [DetailsTabComponent],
  exports: [DetailsTabComponent],
})
export class DetailsTabModule {}
